import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { DynamicValueInput } from './LoanActionItems';

const LoanActionRunLoanCalculationsRow = ({
  index,
  rootPath,
  isDisabled,
  isEditAllowed,
  options,
}) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <div>
      <DynamicValueInput
        required
        disabled={isDisabled || !isEditAllowed}
        label="Save Mode"
        name={`${fieldPath}.saveMode`}
        options={options}
        type={FieldTypesEnum.SELECT}
      />
      <DynamicValueInput
        disabled={isDisabled || !isEditAllowed}
        label="Save without program if current program is invalid"
        name={`${fieldPath}.saveWithoutProgramWhenInvalid`}
        type={FieldTypesEnum.BOOLEAN}
      />
    </div>
  );
};

LoanActionRunLoanCalculationsRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  options: PropTypes.array.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
};

export default memo(LoanActionRunLoanCalculationsRow);
